// 环境变量配置
export const ENV = {
  // API 基础 URL
  // - 开发：走 umi proxy（config/proxy.ts 的 /api、/v1），请求同源 localhost:3000
  // - 生产：与前端同域，由网关/反代转发 /api、/v1
  API_BASE_URL:
    process.env.NODE_ENV === 'production' ? window.location.origin : '',

  // 是否为开发环境
  isDev: process.env.NODE_ENV === 'development',

  // 是否为生产环境
  isProd: process.env.NODE_ENV === 'production',
} as const;
